<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div>
      <div class="row">
				<div class="col-md-12">
          <h3 v-if="lock.LockName"><i class="fa fa-fw fa-unlock-alt"></i> {{ lock.LockName }}</h3>
        </div>
      </div>
      <lock-info v-if="locked" :locked="locked" :lockStatus="lockStatus" v-on:forceLock="getComponentLock(true)" />
      <editor-tabs id="tabNavi" :tabs="tabList" :selected="selectedTab" :id-prefix="tabIdPrefix" v-on:select="tab" />
      <div class="tab-content">
        <transition name="fade" mode="out-in">
          <div v-bind="tabPanel('general')" class="tab-pane active" id="general" v-if="isTabActive('general')" key="general">
            <div class="row">
              <div class="col-sm-6 leftcol">
                <h3>{{ _('General') }}</h3>
                <div class="form-group">
                  <label for="name">{{ _('Name') }}</label>
                  <input type="text" class="form-control" v-model="lock.LockName" />
                </div>
                <div class="form-group">
                  <label for="HouseName">{{ _('House name') }}</label>
                  <input readonly="true" id="HouseName" type="text" class="form-control" v-model="lock.HouseName" />
                </div>
                <div class="form-group">
                  <label for="battery">{{ _('Battery') }}</label>
                  <span id="battery">{{ Math.round(lock.battery * 1000) / 10 }}%</span>
                  <template v-if="lock.LockStatus">
                    <label for="status">{{ _('Status') }}</label>
                    <span id="status">{{ lock.LockStatus.status }}</span>
                    <button class="btn btn-xs" type="button" v-on:click="remoteOperate('lock')" :disabled="!isRemoteOperateEnabled"><i class="fa fa-fw fa-lock"></i> {{ _('Lock') }}</button>
                    <button class="btn btn-xs" type="button" v-on:click="remoteOperate('unlock')" :disabled="!isRemoteOperateEnabled"><i class="fa fa-fw fa-unlock"></i> {{ _('Unlock') }}</button>
                    <label for="doorstate">{{ _('Door') }}</label>
                    <span id="doorstate">{{ lock.LockStatus.doorState }}</span>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <div class="tab-content">
        <transition name="fade" mode="out-in">
          <div v-bind="tabPanel('details')" class="tab-pane active" id="details" v-if="isTabActive('details')" key="details">
            <div class="row">
              <div class="col-sm-6 leftcol">
                <h3>{{ _('Details') }}</h3>
                <div class="form-group">
                  <label for="created">{{ _('Created') }}</label>
                  <input readonly="true" id="created" type="text" class="form-control" v-model="created" />
                </div>
                <div class="form-group">
                  <label for="updated">{{ _('Updated') }}</label>
                  <input readonly="true" id="updated" type="text" class="form-control" v-model="updated" />
                </div>
                <div class="form-group">
                  <label for="LockID">{{ _('Lock ID') }}</label>
                  <input readonly="true" id="LockID" type="text" class="form-control" v-model="lock.LockID" />
                </div>
                <div class="form-group">
                  <label for="HouseID">{{ _('House ID') }}</label>
                  <input readonly="true" id="HouseID" type="text" class="form-control" v-model="lock.HouseID" />
                </div>
                <div class="form-group">
                  <label for="HouseName">{{ _('House name') }}</label>
                  <input readonly="true" id="HouseName" type="text" class="form-control" v-model="lock.HouseName" />
                </div>
                <div class="form-group">
                  <label for="macAddress">{{ _('MAC Address') }}</label>
                  <input readonly="true" id="macAddress" type="text" class="form-control" v-model="lock.macAddress" />
                </div>
                <div class="form-group">
                  <label for="skuNumber">{{ _('SKU number') }}</label>
                  <input readonly="true" id="skuNumber" type="text" class="form-control" v-model="lock.skuNumber" />
                </div>
                <div class="form-group">
                  <label for="SerialNumber">{{ _('Serial number') }}</label>
                  <input readonly="true" id="SerialNumber" type="text" class="form-control" v-model="lock.SerialNumber" />
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <div class="tab-content">
        <transition name="fade" mode="out-in">
          <div v-bind="tabPanel('users')" class="tab-pane active" id="users" v-if="isTabActive('users')" key="users">
            <div class="row">
              <div class="col-sm-12 leftcol">
                <button class="btn btn-success pull-right" type="button" v-on:click="createUserDialog">{{ _('Create new...') }}</button>
                <h3>{{ _('Users') }}</h3>
                <button class="btn btn-info" type="button" v-on:click="createRule">{{ _('Create rule') }}</button>
                <table class="table table-striped sortable" v-if="lock.users">
                  <thead>
                    <tr>
                      <th>{{ _('Name') }}</th><th>{{ _('Type') }}</th>
                    </tr>
                  </thead>
                  <tbody class="users" id="users">
                    <tr v-for="user in lock.users" class="user">
                      <td>{{ user.FirstName }} {{ user.LastName }}</td>
                      <td>{{ user.UserType }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <div class="tab-content">
        <transition name="fade" mode="out-in">
          <div v-bind="tabPanel('pins')" class="tab-pane active" id="pins" v-if="isTabActive('pins')" key="pins">
            <div class="row">
              <div class="col-sm-12 leftcol">
                <h3>{{ _('Pin Codes') }}</h3>
                <table class="table table-striped sortable" v-if="lock.pins && lock.pins.loaded">
                  <thead>
                    <tr>
                      <th>{{ _('User') }}</th><th>{{ _('Type') }}</th><th>{{ _('Pin') }}</th><th>{{ _('Times') }}</th>
                    </tr>
                  </thead>
                  <tbody class="pins" id="pins">
                    <tr v-for="pin in lock.pins.loaded" class="pin">
                      <td>{{ pin.firstName }} {{ pin.lastName }}</td>
                      <td>{{ pin.accessType }}</td>
                      <td>{{ pin.pin }}</td>
                      <td><template v-if="pin.accessStartTime">{{ DateTime.fromISO(pin.accessStartTime).toFormat(dateFormat + " '" + _('at') + "' " + DateTime.fromISO(pin.accessStartTime).toFormat(timeFormat)) }} - {{ DateTime.fromISO(pin.accessEndTime).toFormat(this.dateFormat + " '" + this._('at') + "' " + DateTime.fromISO(pin.accessEndTime).toFormat(this.timeFormat)) }}</template></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <nav class="save-bar">
      <div class="row">
        <div class="col-md-12">
          <div class="pull-right">
            <button class="btn btn-default" v-on:click="close"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
            <button class="btn btn-success" v-on:click="save" :disabled="!isSaveButtonEnabled"><i :class="'fa fa-fw fa-' + saveButtonIcon"></i> {{ saveButtonText }}</button>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>

import axios from 'axios'
import { DateTime } from 'luxon'
import changewatcher from '~/lib/changewatcher'
import components from '~/lib/components'

export default {
  data () {
    return {
      lock: {},
      DateTime: DateTime,
      operating: false
    }
  },
  mixins: [changewatcher, components],
  computed: {
    tabList () {
      return this.editorTabs([
        { id: 'general', label: this._('General') },
        { id: 'details', label: this._('Details') },
        { id: 'users', label: this._('Users') },
        { id: 'pins', label: this._('Pin Codes') }
      ])
    },
    created: {
      get () {
        return this.lock && this.lock.Created ? DateTime.fromISO(this.lock.Created).toFormat(this.dateFormat + " '" + this._('at') + "' " + DateTime.fromISO(this.lock.Created).toFormat(this.timeFormat)) : null
      },
      set () {}
    },
    updated: {
      get () {
        return this.lock && this.lock.Updated ? DateTime.fromISO(this.lock.Updated).toFormat(this.dateFormat + " '" + this._('at') + "' " + DateTime.fromISO(this.lock.Updated).toFormat(this.timeFormat)) : null
      },
      set () {}
    },
    isRemoteOperateEnabled () {
      return !this.operating
    }
  },
  methods: {
    getSaveData () {
      const exportFields = [
        'LockId',
        'LockName',
      ]
      const data = exportFields.reduce((a, e) => (a[e] = this.lock[e], a), {})
      return data
    },
    createUserDialog () {
      this.showDialog({
        title: this._('Create User'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'ban',
            handler: () => {}
          },
          {
            title: this._('Create'),
            class: 'success',
            icon: 'check',
            requiredFields: ['FirstName', 'LastName'],
            handler: this.createUser
          }
        ],
        fields: [
          {
            title: this._('First name'),
            type: 'text',
            name: 'FirstName'
          },
          {
            title: this._('Last name'),
            type: 'text',
            name: 'LastName'
          },
          /*
          {
            title: this._('Email'),
            type: 'text',
            name: 'Email'
          },
          {
            title: this._('Phone'),
            type: 'text',
            name: 'PhoneNo'
          },
          */
        ]
      })
    },
    async createUser (data) {
      let response
      data.LockID = this.lock.LockID
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/yaleusers.json?apikey=' + this.apiKey, data)
      } catch(e) {
        this.showError(e)
        return
      }
      console.log(response)
      this.showNotification(this._('User created!'))
    },
    async createRule () {
      const data = {
        UserID: 'f999d60e-1aa4-4a18-9bcb-494c2cbb29b3',
        LockID: '5214045745DD83D4E418A839660C4B81',
        FirstName: 'Esa',
        LastName: 'Kumikola',
      }
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/yaleusers.json?apikey=' + this.apiKey, data)
      } catch(e) {
        this.showError(e)
        return
      }
      console.log(response)
    },
    async remoteOperate (action) {
      this.operating = true
      const data = {
        id: this.lock.LockID,
        action
      }
      let response
      try {
        response = await axios.patch(this.baseDomain + this.shopId + '/yalelocks/' + this.lock.LockID + '.json?apikey=' + this.apiKey, data)
      } catch(e) {
        this.operating = false
        return this.showError(e)
      }
      if (response && response.data && response.data.info) {
        this.showNotification(this.getRemoteOperateSuccessMessage(action, response.data.info.lockStatusChanged))
      }
      this.operating = false
      this.loadLock(this.lock.LockID)
    },
    getRemoteOperateSuccessMessage (action, statusChanged) {
      switch(action) {
        case 'lock':
          return statusChanged ? this._('Door locked.') : this._('The door was already locked.')
        case 'unlock':
          return statusChanged ? this._('Door unlocked.') : this._('The door was already unlocked.')
        default:
          return ''
      }
    },
    async save () {
      this.saving = true
      const data = this.getSaveData()
      let response
      try {
        response = await axios.put(this.baseDomain + this.shopId + '/yalelocks/' + data.LockId + '.json?apikey=' + this.apiKey, data)
      } catch(e) {
        this.saving = false
        return this.showError(e)
      }
      if (response && response.data && response.data.LockId) {
        await this.loadLock(response.data.LockId)
      }
      this.saving = false
      this.saved = true
      this.storeState()
      setTimeout(() => { this.saved = false }, 1000)
      this.showNotification(this._('Changes saved successfully!'))
      this.$emit('save', this.resource)
      if (this.saveShouldClose) {
        this.close()
      }
    },
    loadLock (id) {
      return new Promise(async (resolve, reject) => {
        this.loading = true
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/yalelocks/' + id + '.json?apikey=' + this.apiKey)
        } catch (e) {
          this.loading = false
          this.showError(e)
          reject()
          return
        }
        this.lock = response.data
        this.storeState()
        this.loading = false
        resolve(this.lock)
      })
    }
  },
  created () {
    if (this.component && this.component.initData) {
      this.loadLock(this.component.initData.lockId)
    }
  },
  async updated () {
    if (this.component && this.component.initData) {
      if (this.lock && this.lock.LockId && this.lock.LockId !== this.component.initData.lockId) {
        try {
          await this.loadLock(this.component.initData.lockId)
        } catch(e) {}
      }
    }
  },
  async mounted () {
    if(!this.events) {
      let events = {}
      events['yaleLockUpdate'] = async (message) => {
        if (message && message.data && this.lock && message.data.LockId === this.lock.LockId) {
          if (!this.unsavedChanges) { // Only update if we haven't made any changes
            this.loadLock(message.data.LockId)
          }
        }
      }
      this.events = events
    }
    this.enableEventBus()
  },
}
</script>